<div class="spinner-row" *ngIf="!listo">
	<div class="spinner-container">
		<img src="Inmuebles/assets/iconos/spinner.gif">
	</div>
</div>

<div class="detalle-view" *ngIf="listo">

    <div class="error-block" *ngIf="error">
        <h2 class="titulo-error">Lo sentimos, el inmueble {{ folio }} ya no se encuentra disponible.</h2>
    </div>

    <div class="detalle" *ngIf="!error">

        <div class="detalle-layout">

            <div class="galeria-inmueble">

                <div *ngIf="imagenes.length === 0" class="imagen-principal text-center w-100">
                    <img src="Inmuebles/assets/img/imagenes.svg" class="img-principal" alt="Sin imágenes disponibles" />
                </div>

                <div *ngIf="imagenes.length > 0">
                    <div class="row">

                        <div class="imagen-principal">
                            <img [src]="imagenes[0] || 'Inmuebles/assets/img/imagenes.svg'" class="img-principal"
                                onerror="this.src='Inmuebles/assets/img/imagenes.svg'"
                                (load)="verificarImagen($event, 'Inmuebles/assets/img/imagenes.svg')"
                                alt="Imagen principal" style="cursor: pointer;" (click)="abrirGaleria(0)" />
                        </div>

                        <div id="carouselInmuebles" class="carousel slide w-100" data-bs-ride="carousel">
                            <div class="carousel-inner w-100">
                                <div *ngFor="let grupo of gruposImagenes; let i = index" class="carousel-item"
                                    [ngClass]="{ active: i === 0 }">
                                    <div class="imagenes-slide">
                                        <div class="miniatura" *ngFor="let img of grupo; let j = index">
                                            <img [src]="img || 'Inmuebles/assets/img/nd_gallery.svg'" alt="Miniatura"
                                                class="img-fluid" style="cursor: pointer;"
                                                onerror="this.src='Inmuebles/assets/img/nd_gallery.svg'"
                                                (load)="verificarImagen($event, 'Inmuebles/assets/img/nd_gallery.svg')"
                                                (click)="abrirGaleria(obtenerIndiceGlobal(i, j))" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="carousel-controles">
                                <button class="custom-arrow" (click)="moverCarrusel(-1)">
                                    <img src="Inmuebles/assets/iconos/chevron-left.svg" alt="Anterior"
                                        class="arrow-icon" />
                                </button>

                                <div class="carousel-indicators carousel-indicators-custom">
                                    <button *ngFor="let grupo of gruposImagenes; let i = index" type="button"
                                        data-bs-target="#carouselInmuebles" [attr.data-bs-slide-to]="i"
                                        [ngClass]="{ active: i === 0 }" [attr.aria-label]="'Slide ' + (i + 1)"></button>
                                </div>

                                <button class="custom-arrow" (click)="moverCarrusel(1)">
                                    <img src="Inmuebles/assets/iconos/chevron-right.svg" alt="Siguiente"
                                        class="arrow-icon" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="info-inmueble">
                <h2 class="info-title">{{ detalle.tipoInmueble }} en {{ detalle.estado }} - {{ detalle.ciudad }}</h2>
                <p class="folio-label">Folio: {{ detalle.folio.slice(-5) }}</p>
                <div class="inmueble-datos">
                    <p class="price-label" *ngIf="detalle.precio === 1">En actualización</p>
                    <p class="price-label" *ngIf="detalle.precio !== 1">${{ detalle.precio | number:'1.0-2' }} pesos</p>

                    <div class="inmueble-inf">
                        <div><label class="medium-label">Descripción: </label><span class="book-label"> {{ detalle.descripcion }}</span></div>
                        <div><label class="medium-label">Dirección: </label><span class="book-label"> {{ detalle.direccion }}</span></div>
                        <div><label class="medium-label">Gerente de ventas: </label><span class="book-label"> {{ capitalizeFirstLetter(detalle.nombreGerente) }}</span></div>
                        <div><label class="medium-label">Subtipo: </label><span class="book-label"> {{ detalle.subtipo }}</span></div>
                        <div><label class="medium-label">Estatus: </label><span class="book-label"> {{ estatusOps[detalle.estatus] }}</span></div>
                        <div><label class="medium-label">Dimensiones: </label><span class="book-label"> {{ detalle.m2Terreno }} m²</span></div>
                    </div>
                </div>

                <div class="btns align-items-center">
                    <a type="button" (click)="obtenerFichaTecnica()" class="btn-detalle"><img
                            src="Inmuebles/assets/iconos/icono_ficha.svg" style="height: 24px; width: 24px;" alt="" />
                        Ficha técnica
                    </a>
                    <a type="button" class="btn-detalle" (click)="abrirShareModal()"><img
                            src="Inmuebles/assets/iconos/icono_compartir.svg" style="height: 24px; width: 24px;"
                            alt="" />
                        Compartir
                    </a>
                </div>
            </div>
        </div>
        <!--ROW DE MAPA-->
        <div class="map-container">
            <label class="titulo-mapa">Ubicación</label>
            <google-map height="412.02px" width="100%" [center]="center" [zoom]="zoom" [options]="mapOptions">
                <!-- <map-marker [position]="center" [title]="'Ubicación Central'">
                        </map-marker> -->
            </google-map>
        </div>
    </div>
</div>

<!-- Modal para compartir -->
<div class="modal fade" #shareModal id="shareModal" tabindex="-1" role="dialog" aria-labelledby="shareModalLabel" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <button type="button" class="close-button" aria-label="Cerrar" data-bs-dismiss="modal">
                <img src="Inmuebles/assets/iconos/close-button.svg" alt="Cerrar">
            </button>
            <img src="Inmuebles/assets/iconos/compartir_icon.svg" alt="" class="compartir-icono" />
            <p class="modal-subtitle">Compartir</p>
            <p class="modal-text">Seleccione una opción para compartir.</p>
            <div class="buttons-row">
                <a [href]="getWhatsappUrl(detalle)" 
                    target="_blank" 
                    class="modal-button whatsapp-button">
                    <img src="Inmuebles/assets/iconos/wa_icon.svg" alt="" class="icon-img whatsapp-icon" />
                    Whatsapp
                </a>
                <button type="button" (click)="cambiarModal()" class="modal-button correo-button"
                    data-bs-dismiss="modal">
                    <img src="Inmuebles/assets/iconos/correo_icon.svg" alt="" class="icon-img correo-icon" />
                    Correo
                </button>
            </div>
        </div>
    </div>
</div>

    <app-carrusel></app-carrusel>
    <app-contactanos-detalle [detalle]="detalle" idTipoSolicitud="3" *ngIf="detalle"></app-contactanos-detalle>
    
<!-- Modal correo -->
<form autocomplete="off" (ngSubmit)="recomendarAUnAmigo()" [formGroup]="formRecomendar">
    <div class="modal fade" #recomendarModal id="recomendarModal" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <button type="button" class="close-button" aria-label="Cerrar" data-bs-dismiss="modal"
                    (click)="cerrarModalRecomendar()">
                    <img src="Inmuebles/assets/iconos/close-button.svg" alt="Cerrar">
                </button>

                <div class="correo-header">
                    <img src="Inmuebles/assets/iconos/Mensaje.svg" alt="Correo" class="correo-icono" />
                    <h4 class="modal-subtitle">Correo</h4>
                </div>

                <div class="correo-form">
                    <div class="input-wrapper" [class.error]="formRecomendar.get('remitente')?.touched && formRecomendar.get('remitente')?.errors && formRecomendar.get('remitente')?.value">
                        <input type="text" class="custom-input" maxlength="50" placeholder="" formControlName="remitente"
                            autocomplete="off" required />
                        <label class="floating-label">Nombre(s)*</label>
                        <div *ngIf="formRecomendar.get('remitente')?.touched && formRecomendar.get('remitente')?.errors">
                            <label class="helper-error" *ngIf="formRecomendar.get('remitente')?.errors?.['longitud']">
                                Ingresa un nombre con más de 2 caracteres.
                            </label>
                            <label class="helper-error" *ngIf="formRecomendar.get('remitente')?.errors?.['repetidos']">
                                No repitas caracteres seguidos.
                            </label>
                        </div>
                    </div>

                    <div class="input-wrapper" [class.error]="formRecomendar.get('apellido1')?.touched && formRecomendar.get('apellido1')?.errors && formRecomendar.get('apellido1')?.value">
                        <input type="text" class="custom-input" maxlength="50" placeholder="" formControlName="apellido1"
                            autocomplete="off" required />
                        <label class="floating-label">Apellido 1*</label>
                        <div *ngIf="formRecomendar.get('apellido1')?.touched && formRecomendar.get('apellido1')?.errors">
                            <label class="helper-error" *ngIf="formRecomendar.get('apellido1')?.errors?.['longitud']">
                                Ingresa un apellido con más de 2 caracteres.
                            </label>
                            <label class="helper-error" *ngIf="formRecomendar.get('apellido1')?.errors?.['repetidos']">
                                No repitas caracteres seguidos.
                            </label>
                        </div>
                    </div>

                    <div class="input-wrapper" [class.error]="formRecomendar.get('apellido2')?.touched && formRecomendar.get('apellido2')?.errors && formRecomendar.get('apellido2')?.value">
                        <input type="text" class="custom-input" maxlength="50" placeholder="" formControlName="apellido2"
                            autocomplete="off"/>
                        <label class="floating-label">Apellido 2 (Opcional)</label>
                        <div *ngIf="formRecomendar.get('apellido2')?.touched && formRecomendar.get('apellido2')?.errors">
                            <label class="helper-error" *ngIf="formRecomendar.get('apellido2')?.errors?.['longitud']">
                                Ingresa un apellido con más de 2 caracteres.
                            </label>
                            <label class="helper-error" *ngIf="formRecomendar.get('apellido2')?.errors?.['repetidos']">
                                No repitas caracteres seguidos.
                            </label>
                        </div>
                    </div>

                    <div class="input-wrapper">
                        <input type="email" class="custom-input" placeholder="" formControlName="destinatario"
                            autocomplete="off" required />
                        <label class="floating-label">Correo electrónico*</label>
                    </div>

                    <div class="input-wrapper" style="height: 89px;">
                        <textarea class="custom-textarea" placeholder="" formControlName="mensaje" maxlength="100"
                            rows="4" autocomplete="off"></textarea>
                        <label class="floating-label">Escribe un mensaje</label>
                        <div class="text-indicator">
                            {{ formRecomendar.get('mensaje')?.value?.length || 0 }}/100
                        </div>
                    </div>

                    <p class="info-text">Los campos marcados con (*) son obligatorios.</p>
                </div>

                <div class="correo-footer">
                    <button type="button" class="btn-cancelar" id="closeModal" data-bs-dismiss="modal"
                        (click)="cerrarModalRecomendar()">
                        Cancelar
                    </button>
                    <button type="submit" class="btn-enviar" [disabled]="formRecomendar.invalid"
                        data-bs-dismiss="modal">
                        Enviar
                    </button>
                </div>
            </div>
        </div>
    </div>
</form>